import type { ConsumerAddressFields } from "@jti/evo-client";
import type { CasAddressStored } from "@jti/fe-common";

import { convertCasAddressToStoredAddress } from "../convertCasAddressToStoredAddress";

export const prepareAddresses = (addresses: CasAddressStored[] | ConsumerAddressFields[]) => {
  return addresses.map((address) => convertCasAddressToStoredAddress(address));
};

export const prepareAndFindAddress = (
  addresses: CasAddressStored[] | ConsumerAddressFields[],
  addressId: string | number
) => {
  const storedAddresses = addresses.map((address) => convertCasAddressToStoredAddress(address));
  const updatedAddress = storedAddresses.find(({ id }) => id === addressId);

  return {
    storedAddresses,
    updatedAddress,
  };
};
